var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKnowInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#know_info_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.02 16.204c3.207 3.765 10.753 3.765 13.96 0 2.953-3.468 2.729-10.256-.826-13.226-3.184-2.66-9.124-2.66-12.308 0-3.554 2.97-3.778 9.758-.825 13.226Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.209 8.96h2.138v4.947M8.23 13.907h4.254M10.367 5.314v.461"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "know_info_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgKnowInfo;